<!--
 * @Description: 
 * @Date: 2020-05-12 13:46:12
-->
<template>
  <div>
    <table-render :config="imageTableConfig" :propDate="propDate" />
  </div>
</template>

<script>
import { aAlly, taskRecordPic } from '@/api/ajax';
import tableRender from '@/components/tableRender';
import { handleClickItem } from '../renderJS/tool';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import Vue from 'vue';
import store from '@/store/index.js';
import router from '@/router/index';
import { makeSure } from '@/Mixin/makeSure';

const createComponent = component => {
  const Constructor = Vue.extend({ ...component, store, router });
  let instances = new Map();
  const remove = uid => {
    return () => {
      let instancesSize = instances.size;
      if (!instancesSize) {
        throw new Error('没有 ElImageViewer实例');
      }
      let keys = [...instances.keys()];
      let lastKey = keys[keys.length - 1];
      let example = instances.get(uid || lastKey); // 如果没有uid则删除最后一个
      document.getElementById('app').removeChild(example.$el);
      example.$destroy();
      instances.delete(example._uid);
    };
  };
  const initInstance = () => {
    let instance = new Constructor({
      el: document.createElement('div')
    });
    let { _uid } = instance;
    instances.set(_uid, instance);
    instance.remove = remove(_uid);
    return instance;
  };
  const ElImageViewer = options => {
    let instance = initInstance();
    for (let prop in options) {
      if (options.hasOwnProperty(prop)) {
        instance[prop] = options[prop];
      }
    }
    instance.$mount();
    document.getElementById('app').appendChild(instance.$el);
    Vue.nextTick(() => {
      instance.visible = true;
    });
    return instance;
  };
  ElImageViewer.clear = () => {
    instances.forEach(item => {
      document.getElementById('app').removeChild(item.$el);
      item.$destroy();
    });
    instances.clear();
  };
  ElImageViewer.remove = remove();
  return ElImageViewer;
};

export default {
  props: ['row', 'projectType'],
  mixins: [makeSure],
  data() {
    const that = this;
    const customImageViewer = createComponent(ElImageViewer);
    return {
      imageTableConfig: [
        {
          name: '修改历史',
          childMenu: [
            {
              list: taskRecordPic.listRepeatPic,
              requestNow: true,
              fields: [
                {
                  width: '100px',
                  label: '任务月度',
                  prop: 'taskDt'
                },
                {
                  width: '100px',
                  label: '项目参与人',
                  prop: 'fullName'
                },
                {
                  width: '600px',
                  label: '重复图片',
                  render(h, ctx, row, column, columnIndex) {
                    return (
                      <div style="display:flex;flex-wrap:wrap;">
                        {(['', 'null', null, undefined].includes(
                          row.repeatImgUrls
                        )
                          ? []
                          : row.repeatImgUrls.split(',')
                        ).map((item, index, arr) => {
                          return (
                            <el-image
                              style="margin-right: 10px;margin-bottom:10px;width:50px;height:40px;"
                              src={item}
                              onClick={() => {
                                const prevOverflow =
                                  document.body.style.overflow;
                                document.body.style.overflow = 'hidden';
                                customImageViewer({
                                  onClose: () => {
                                    document.body.style.overflow = prevOverflow;
                                    customImageViewer.remove();
                                  },
                                  zIndex: 3000,
                                  urlList: arr,
                                  index: index
                                });
                                handleClickItem(that.$parent);
                              }}
                            />
                          );
                        })}
                      </div>
                    );
                  }
                },
                {
                  width: '80px',
                  label: '操作',
                  render(h, ctx, row, column, columnIndex) {
                    return (
                      <el-button
                        type="text"
                        disabled={row.auditStatus != 2}
                        onClick={() => {
                          let delEvent = row => {
                            aAlly
                              .taskNotPass({
                                planId: row.repeatTaskId,
                                projectType: that.projectType
                              })
                              .then(res => {
                                this.$notify({
                                  title: '成功',
                                  message: '操作成功',
                                  type: 'success'
                                });
                              })
                              .catch(() => {
                                ctx.parent.saveSuccess();
                              });
                          };
                          that.makeSureEvent(delEvent, row);
                        }}
                      >
                        不通过
                      </el-button>
                    );
                  }
                }
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    propDate() {
      return {
        query: {
          currentTaskId: this.row.id,
          projectType: this.projectType,
          sceneType: this.projectType,
          childNotSetPageNumStoreFlag: true
        }
      };
    }
  },
  components: {
    ElImageViewer,
    tableRender
  }
};
</script>
